module.exports = __webpack_public_path__ + "img/copy.4b5d72cb.svg";